import React, { Component } from "react";
import ReactDOM from "react-dom";

class EnvironmentSign extends Component {
  render() {
    const { color, text } = this.props;

    const leftPad = text.length * 45;
    // return null;
    return ReactDOM.createPortal(
      <div>
        <span
          style={{
            color,
            fontSize: "150px",
            opacity: 0.3,
            position: "fixed",
            top: "calc(50% - 100px)",
            left: `calc(50% - ${leftPad}px)`,
            pointerEvents: "none",
            zIndex: 100000,
          }}
        >
          {text}
        </span>
      </div>,
      document.getElementById("modal-env-sign")
    );
  }
}

export default EnvironmentSign;
